import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import socket from "../../socketcontext/socket-context";
import { myConfig } from "../../config";

const QRcode = (props) => {
  const serverAddress = myConfig.serverAddress;
  const [data, setData] = useState({});
  const [salesman, setSalesman] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      const result = await axios.get(`${serverAddress}/api/qrcode`, {});
      setData(result.data);

      const salesman = await axios.get(`${serverAddress}/api/salesman`);
      setSalesman(salesman.data);
    };

    socket.emit("Send-Username", localStorage.getItem("user"));
    fetchData();
  }, []);

  socket.on("receive data", (data) => {
    if (!data.url) {
      props.history.push({
        pathname: "/termsandconditions",
        state: { data }
      });
    }
  });

  return (
    <Fragment>
      {salesman ? (
        <div className="main">
          <br />
          <br />
          <div>Salesman: {salesman.name}</div>
          <div>Mobile: {salesman.mobile}</div>
          <br />
          <p>
            Dear Customer,
            <br />
            &emsp;&emsp;Please scan the QR code below using your Singpass app to
            securely transmit your personal details to the salesperson and Motor
            Image Enterprises for the test drive.
          </p>
          <div className="imgQc">
            <img
              src={`${data.url}`}
              alt=""
              title=""
              style={{ height: "200px", width: "200px" }}
            />
          </div>
          <div style={{textAlign:"center",marginTop:"25px"}}>
            <img src={require("../../images/retrievebutton.png")} alt="" />
          </div>
        </div>
      ) : null}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  state: state
});

export default connect(mapStateToProps)(QRcode);
